import { render, staticRenderFns } from "./SignActionResult.vue?vue&type=template&id=44063054&"
import script from "./SignActionResult.vue?vue&type=script&lang=js&"
export * from "./SignActionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports